<template>
  <div class="kyc-footer">
    <img class="icon-lock" src="@assets/images/lock.svg">
    {{ $t('content') }}
    <img class="icon-persona" src="@assets/images/persona.svg">


    <span class="divider" />

    <a target="_blank" href="https://www.shipbob.com/privacy-policy/">{{ $t('privacy') }}</a>
  </div>
</template>
<script>

export default {
  name: 'KYCFooter',
  i18n: {
    messages: {
      'en-US': {
        content: 'All information is secured with',
        privacy: 'ShipBob\'s Privacy Policy'
      }
    }
  }
}

</script>
<style scoped lang='scss'>
.icon-lock {
  padding-right: 0.3em;
  margin-top: 0.2em;
  height: 1em;
}

.icon-persona {
  padding-left: 0.3em;
  padding-top: 0.3em;
  margin-top: 0.1em;
  height: 1.3em;
}

.divider {
  margin: 0.3em 0.5em;
  height: 1em;
  border: 0.5px solid #999999;
}

.kyc-footer {
  border-top: 1px solid #999999;
}
</style>
